import { connect } from 'react-redux';
import { getVerificationEmailAddress } from '../../../publicSession/selectors';
import { getSiteHeaderState } from '../../redux/selectors';
import { resetNewFeedback, toggleNotificationsDropdown, } from '../../redux/actions';
var mapStateToProps = function (state) {
    var headerState = getSiteHeaderState(state);
    return {
        verificationEmail: getVerificationEmailAddress(state),
        hasBeenOpened: headerState.hasNotificationsDropdownBeenOpened,
        newFeedbackCount: headerState.newFeedbackCount,
    };
};
var mapDispatchToProps = {
    resetNewFeedback: resetNewFeedback,
    toggleNotificationsDropdown: toggleNotificationsDropdown,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NotificationsDropdown.container.js.map